import { renderRichText } from '@storyblok/js';
import { sanitizeHtml } from './sanitize-html';

export function convertStoryblokRichTextToHtml(richText) {
  if (!richText) return '';

  if (typeof richText === 'string') {
    // Sanitise (pen test MOB-3): plain-string / textarea Storyblok fields (e.g. titles)
    // reach v-html via StoryblokRenderer with isHtml defaulting true, so a raw
    // `<img onerror=…>` here would otherwise execute.
    return sanitizeHtml(richText);
  }

  if (richText && typeof richText === 'object' && richText.type === 'doc') {
    try {
      // richtext v5: renderRichText returns an HTML string directly.
      // Embedded component bloks are blanked via the `renderers` map
      // (v5 replaces the v4 singular `resolver` option).
      let html =
        renderRichText(richText, {
          renderers: { blok: () => '' },
        }) || '';

      html = html.replace(/<p><\/p>/g, '<br>');
      html = html.replace(/<p>\s*<\/p>/g, '<br>');

      // Keep emoji on the same line as the text around them.
      //
      // v4 wrapped an emoji node in `span[data-type='emoji']`, which every rich-text
      // component styled to force the img back inline. v5 emits a bare
      // `<img data-emoji>`, so those selectors are dead and Tailwind preflight's
      // `img, svg, video, … { display: block }` applies unopposed, putting every
      // emoji on its own line.
      //
      // The utility is injected here rather than written on a template because this
      // markup reaches the DOM through `v-html` — there is no element to put a class
      // on. One `inline` is enough: the renderer's own inline style already carries
      // the 1.25em box and `vertical-align: text-top`.
      html = html.replace(/<img(?=[^>]*\sdata-emoji=)/g, '<img class="inline"');

      // Sanitise before it reaches v-html (pen test MOB-3): CMS rich text is
      // attacker-influenceable if a Storyblok editor account is compromised.
      return sanitizeHtml(html);
    } catch (error) {
      console.warn('Error rendering Storyblok rich text:', error, richText);
      return '';
    }
  }

  if (richText && typeof richText === 'object') {
    return sanitizeHtml(richText.text || richText.content || '');
  }

  return sanitizeHtml(String(richText));
}
